import React, { useState } from 'react'
import { backendUrl, I_POP_OVER, SUBSCRIPTION_MODULE_TYPE } from '../../constants'
import CurrencyFormat from '../../components/currencyFormat/currencyFormat'
import Currency from '../../components/currency'
import InfoModalStatic from '../dashboard/infoModalStatic';
import { useSelector } from 'react-redux';

export default function PlanCardList({
    productPlanList,
    planButtonTrigger,
    name,
    activeType
}) {
    const { selectedCompany } = useSelector((state) => state.company);

    const shortenDescription = (description) => {
        const plainText = description.replace(/<\/?[^>]+(>|$)/g, "");
        const shortenedDescription =
            plainText.length > 100 ? plainText.substring(0, 70) + "..." : plainText;
        return shortenedDescription;
    };


    const [infoModalStaicShow, setInfoModalStaticShow] = useState(false)
    const [infoModalStaicShowType, setInfoModalStaicShowType] = useState(false)
    return (
        <div>
            <p className={`planTypeName ${activeType === SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN ? "marginTopPlan" : ""}`}>{name} <img src="assets/img/planTypeInfo.svg" alt="planTypeInfo" onClick={() => {
                if (activeType === SUBSCRIPTION_MODULE_TYPE.PLAN) {
                    setInfoModalStaicShowType(I_POP_OVER.COMPANY_PLAN)
                } else {
                    setInfoModalStaicShowType(I_POP_OVER.SERVICES_PLAN)
                }
                setInfoModalStaticShow(true)
            }} /> </p>
            <div className="row">
                {productPlanList.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => planButtonTrigger(item)}
                        className='col-12 col-md-3'>
                        <div className={activeType === SUBSCRIPTION_MODULE_TYPE.PLAN ? "companyPlan" : "bussinessPlan"}>
                            <div className="productHolder">
                                <div className="productImageHolder">
                                    <div className="d-flex align-items-start justify-content-between productStockKeyHolder">
                                        <p className="suggestedText">
                                            {selectedCompany?.subscriptionPlan &&
                                                Object.keys(selectedCompany?.subscriptionPlan)
                                                    .length > 0 &&
                                                selectedCompany?.subscriptionPlan?._id ===
                                                item?.id && (
                                                    <div className="suggestedText">
                                                        SUGGESTED{" "}
                                                        {item?.planType?.value === SUBSCRIPTION_MODULE_TYPE.PLAN
                                                            ? "PLAN" : "SERVICE"}
                                                    </div>
                                                )}
                                        </p>
                                    </div>
                                    <div
                                        className="productImage"
                                        style={{ backgroundImage: `url(${backendUrl + item?.mobileImage?.filename})`, }}></div>

                                    <div className="hover-content">
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    item?.description ||
                                                    shortenDescription(item?.targetAudience),
                                            }}></p>
                                    </div>
                                </div>
                                <div className="productDetailHolder">
                                    <p>{item?.name}</p>
                                    {(item?.planType?.value !== SUBSCRIPTION_MODULE_TYPE.PLAN && item?.planType?.value !== SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN) &&
                                        <h6>
                                            <Currency currency={item?.currency?.value} />{" "}
                                            <CurrencyFormat
                                                currency={item?.currency?.value}
                                                value={parseFloat(item?.price)}
                                                decimal={2}
                                            /> <span>/{item?.planType?.value === SUBSCRIPTION_MODULE_TYPE.PLAN ? 'm' : "yearly"}</span>
                                        </h6>
                                    }
                                    {/* {item?.smallDescription && (
                                        <p className="productSlug">
                                            {item?.smallDescription}
                                        </p>
                                    )} */}
                                    <button type="button">
                                        View more
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <InfoModalStatic
                infoModalStaticShow={infoModalStaicShow}
                infoModalStaticClose={() => setInfoModalStaticShow(false)}
                infoModalStaicShowType={infoModalStaicShowType}
            />
        </div>

    )
}
